import {keepPreviousData, useQuery} from '@tanstack/react-query';
import {useKeyplayApi} from '../../context/ApiContext';
import {AccountFilter} from '../../shared/filter/accountFilter';
import {ScoredAccountsResponse} from '../../shared/api/responses';

/**
 * Fetches a preview of accounts matching the given filter.
 * Returns up to 20 accounts with totalLength for display in the preview panel.
 */
export const useDynamicListPreview = (filter: AccountFilter) => {
  const makeApiCall = useKeyplayApi();

  return useQuery<ScoredAccountsResponse>({
    queryKey: ['dynamicListPreview', JSON.stringify(filter)],
    queryFn: () =>
      makeApiCall<ScoredAccountsResponse>('/scoredAccounts', {
        params: {
          query: {
            filter,
            sort: {field: 'overallFit', order: 'desc'},
            limit: 20,
          },
        },
      }),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });
};
